import { render, staticRenderFns } from "./LinkarColaborador.vue?vue&type=template&id=eafe3704&scoped=true&"
import script from "./LinkarColaborador.vue?vue&type=script&lang=js&"
export * from "./LinkarColaborador.vue?vue&type=script&lang=js&"
import style0 from "./LinkarColaborador.vue?vue&type=style&index=0&id=eafe3704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafe3704",
  null
  
)

export default component.exports